// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3LPaz","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1C2hu"};